import PropTypes from 'prop-types';

import styles from '../Messages.module.scss';

const Date = props => {
  return (
    <div className={styles.date}>
      <p className={styles.date__content}>{props?.text}</p>
    </div>
  );
};

Date.propTypes = {
  text: PropTypes.string,
};

export default Date;
